import { format } from '../../_snowpack/pkg/date-fns.js';
import numeral from '../../_snowpack/pkg/numeral.js';
export function formatDate(value, dateFormat = 'PP') {
  return !!value ? format(new Date(value), dateFormat) : '';
}
export function formatCurrency(value) {
  return !!value ? numeral(value).format('$0,0.00') : '-';
}
export function formatNumber(value) {
  return numeral(value).format('0,0');
}
export function mapToSelectValue(options, value) {
  return options.find(x => value == x.value); // MUST use ==
}
export function mapToSelectValues(options, values) {
  return options.filter(x => values.includes(x.value));
}
export function toPagination(res, pageNumber, pageSize) {
  let totalItemCount = res['@odata.count'];
  let pageCount = totalItemCount > 0 ? Math.ceil(totalItemCount / pageSize) : 0;
  let firstItemOnPage = (pageNumber - 1) * pageSize + 1;
  let numberOfLastItemOnPage = firstItemOnPage + pageSize - 1;
  return {
    items: res.value,
    meta: {
      pageCount,
      totalItemCount,
      pageNumber,
      pageSize,
      hasPreviousPage: pageNumber > 1,
      hasNextPage: pageNumber < pageCount,
      isFirstPage: pageNumber === 1,
      isLastPage: pageNumber == pageCount,
      firstItemOnPage,
      lastItemOnPage: numberOfLastItemOnPage > totalItemCount ? totalItemCount : numberOfLastItemOnPage
    }
  };
}